'use client'

import { IconArrowMoveAi } from 'icons/components/IconArrowMoveAi'
import { cx } from 'utils/cx'

import texts from 'fukku/styles/texts.module.scss'
import type { JSX } from 'react'
import styles from './ListItem.module.scss'

export interface ListBodyProps {
	readonly title: string
	readonly icon?: JSX.Element
	readonly subtitle?: JSX.Element
	readonly titleUpperCase?: boolean
	readonly showArrow?: boolean
}
export function ListBody(props: ListBodyProps) {
	const { title, icon, subtitle, titleUpperCase, showArrow } = props

	return (
		<>
			{icon}
			<div className={cx(styles.body)}>
				<p
					className={cx(
						styles.title,
						titleUpperCase ? texts.uppercaseM : texts.bodyM
					)}
				>
					{title}
				</p>
				{subtitle}
			</div>
			{showArrow && <IconArrowMoveAi width={15} className={styles.iconArrow} />}
		</>
	)
}
